export default "__VITE_ASSET__nIrwH2Bx__"